module.exports = __webpack_public_path__ + "static/homepage-mobile-firstimage-1e71f7c4c61aa5a1a552f1dfe9965096.jpg";